import { render, staticRenderFns } from "./LanguageFlagDropdown.vue?vue&type=template&id=ec085a7c&scoped=true&"
import script from "./LanguageFlagDropdown.vue?vue&type=script&lang=js&"
export * from "./LanguageFlagDropdown.vue?vue&type=script&lang=js&"
import style0 from "./LanguageFlagDropdown.vue?vue&type=style&index=0&id=ec085a7c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec085a7c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
